import {verifiedFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {UpdateIssuesBulk} from '@github-ui/server-persisted-queries'
import type {UpdateIssuesBulkMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulk'

export type UpdateIssueLabelsBulkRequest = {
  ids: string[]
  addedLabelIds: string[]
  removedLabelIds: string[]
}

export type UpdateIssueLabelsBulkResponse = GraphQLResponse<UpdateIssuesBulkMutation>

export async function apiUpdateIssueLabelsBulk(
  request: UpdateIssueLabelsBulkRequest,
): Promise<UpdateIssueLabelsBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body: Record<string, unknown> = {
    ids: request.ids,
    addedLabelIds: request.addedLabelIds,
    removedLabelIds: request.removedLabelIds,
    queryId: UpdateIssuesBulk,
  }

  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }
  const response = await verifiedFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueLabelsBulkResponse>
}
